import mapValues from 'lodash/mapValues';

import {Organization as ApiOrganization, Project as ApiProject, User} from 'app_api/me/types';
import {userDetailsClient} from 'common/report/queries/app-api/user-details-client';
import {toWorkspaceObj, WorkspaceObj} from 'common/report/queries/app-api/workspaces-client';
import {STAFF_DISPLAY_NAME} from 'common/constants';
import {isStaffEmail} from 'common/report/util';

import {Store} from './store';

// getting feature_flags from userDetailsStore is deprecated, use featuresStore instead
export interface Project extends Omit<ApiProject, 'feature_flags'> {
  id: number;
  isDemo: boolean;
  canViewProjectSettings: boolean;
}

export interface Organization extends ApiOrganization {
  isDemo: boolean;
}

export interface UserDetails {
  email: string;
  id: number;
  isStaff: boolean;
  name: string;
  organizations: Record<string, Organization>;
  projects: Record<string, Project>;
  workspaces: Record<string, WorkspaceObj>;
  myDashboardId?: number;
}

export function getProjectFromResponse(project: ApiProject, projectId: string | number): Project {
  return {
    id: parseInt(projectId as string, 10),
    isDemo: project.is_demo,
    canViewProjectSettings: project.permissions && project.permissions.includes(`access_project_settings`),
    ...project,
  };
}

export const userDetailsStore = new Store<UserDetails>({
  apiClient: userDetailsClient,
  defaultValue: {
    email: ``,
    isStaff: false,
    name: ``,
    organizations: {},
    projects: {},
    workspaces: {},
  },
  name: `user-details`,
  transform: {
    index: (userDetails: User): UserDetails => ({
      email: userDetails.user_email,
      id: userDetails.user_id,
      isStaff: userDetails.is_staff,
      name: userDetails.user_name,
      organizations: mapValues(userDetails.organizations, (organization) => ({
        isDemo: organization.is_demo,
        ...organization,
      })),
      projects: mapValues(userDetails.projects, getProjectFromResponse),
      workspaces: mapValues(userDetails.workspaces, (workspace) => toWorkspaceObj(workspace)),
      myDashboardId: userDetails.my_dashboard_id,
    }),
  },
});

/**
 * Show special display name for entities created by mixpanel staff for non-staff users.
 */
export function getEntityCreatorDisplayName(creatorEmail: string, creatorName: string): string {
  if (userDetailsStore.value?.isStaff) {
    return creatorName;
  }

  return isStaffEmail(creatorEmail) ? STAFF_DISPLAY_NAME : creatorName;
}
